exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".error-notification {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  background: #fff;\n  padding: 15px 20px 15px 15px;\n  -webkit-box-shadow: 0 6px 26px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 6px 26px rgba(0, 0, 0, 0.15);\n  border-radius: 8px;\n  color: #555; }\n  .error-notification__icon {\n    color: #ff4d4d;\n    margin-right: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/shared/components/ErrorNotification/index.scss
// module id = 449
// module chunks = 0